var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content",style:(_vm.cur==_vm.index?{backgroundColor:_vm.isSkin}:''),on:{"click":_vm.cilckMethod}},[_c('div',{staticClass:"title",style:(_vm.cur==_vm.index?{color:'#FFF'}:'')},[_vm._v(_vm._s(_vm.item.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }